import API from './base'
import {Deserializer} from 'jsonapi-serializer'

const JSONAPIDeserializer = new Deserializer({keyForAttribute: 'underscore_case'})

export default class Article extends API {

  async getList() {
      try {
        const url = `articles/categories`
        const response = await this.axios.get(url)
        const result = await JSONAPIDeserializer.deserialize(response.data)
        return Promise.resolve(result)
      } catch (err) {
        return Promise.reject(err)
      }
  }

  async getListByCategory(id) {
    try {
      const url = `articles?category=${id}`
      const response = await this.axios.get(url)
      const result = await JSONAPIDeserializer.deserialize(response.data)
      return Promise.resolve(result)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  async getItemById(id) {
    try {
      const url = `articles/${id}`
      const response = await this.axios.get(url)
      const result = await JSONAPIDeserializer.deserialize(response.data)
      return Promise.resolve(result)
    } catch (err) {
      return Promise.reject(err)
    }
  }

}
